var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "cus-alert-dialog-cls",
      attrs: {
        width: "450px",
        visible: _vm.visible,
        "show-close": false,
        top: "30vh"
      },
      on: { close: _vm.handleClose }
    },
    [
      _c("div", { staticClass: "my-cotent" }, [
        _c("div", { staticClass: "top-area" }, [
          _c("div", { staticClass: "left-box" }, [
            _c("img", { attrs: { src: _vm.iconwarning } })
          ]),
          _c("div", { staticClass: "right-box" }, [
            _c("div", { staticClass: "f1" }, [_vm._v("请确认删除操作")]),
            _c("div", { staticClass: "f2" }, [
              _vm._v("删除操作不可逆，请确认操作")
            ])
          ])
        ]),
        _c("div", { staticClass: "btn-area" }, [
          _c(
            "div",
            {
              staticClass: "fg-btn fg-btn-middle fg-btn-default",
              on: {
                click: () => {
                  _vm.visible = false
                }
              }
            },
            [_vm._v(" 取消 ")]
          ),
          _c(
            "div",
            {
              staticClass: "fg-btn fg-btn-middle fg-btn-danger",
              on: { click: _vm.handleConfirm }
            },
            [_vm._v(" 删除 ")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }